module.exports = __webpack_public_path__ + "static/media/hnc.d15597e7.webp";